import React, { useState } from "react";
import { Loader } from "react-bootstrap-typeahead";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import {
    useCreateInstagramConfigurationMutation, useUpdateInstagramConfigurationMutation
} from "../../../Services/settingsAPIs/CommonAPI";
import { toast } from "react-toastify";

interface IPROS {
    closeModal: () => void;
    editModalData: any; // Assuming editModalData is an object with form fields
    modalOpenStatus: string; // Either 'add' or 'edit'
    editModal: any;
    refetch: any

}

const initialValues = {
    access_token: "",
    ig_user_id: "",
};

const registrationSchema = Yup.object().shape({
    access_token: Yup.string().required("Access token is required"),
    ig_user_id: Yup.string().required("IG user id is required"),
});

const WhatsAppModal: React.FC<IPROS> = ({
    closeModal,
    editModalData,
    modalOpenStatus,
    refetch
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [trigger] = useCreateInstagramConfigurationMutation();
    const [updateConfiguration] = useUpdateInstagramConfigurationMutation();

    console.log(editModalData)
    const formik = useFormik({
        initialValues:
            modalOpenStatus === "edit" && editModalData
                ? {
                    access_token: editModalData.access_token || "",
                    ig_user_id: editModalData.user_id || "",
                }
                : { access_token: "", ig_user_id: "" },
        enableReinitialize: true,
        validationSchema: registrationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setIsLoading(true);

                if (modalOpenStatus === "edit") {
                    // Call updateConfiguration for edit
                    const body = {
                        access_token: values.access_token,
                        user_id: values.ig_user_id,
                    };

                    const response = await updateConfiguration({
                        body,
                        id: editModalData.id,
                    });

                    refetch();
                    console.log("Update Response:", response);
                    toast.success("Configuration updated successfully!");
                } else {
                    const body = {
                        access_token: values.access_token,
                        user_id: values.ig_user_id,
                    };
                    const response: any = await trigger({
                        body
                    });
                    refetch();
                    console.log("Create Response:", response);

                    if (response?.error) {
                        // Show error toast with the error message
                        const errorMsg =
                            response.error.data?.non_field_errors?.[0] ||
                            response.error.data?.detail ||
                            "An error occurred";
                        toast.error(errorMsg);
                    } else {
                        toast.success("Configuration created successfully!");
                        closeModal(); // Only close modal on success
                    }
                }

                setIsLoading(false);
                closeModal(); // Close modal on success
            } catch (error) {
                setIsLoading(false);
                console.error("Submission error:", error);
                toast.error("An error occurred while submitting the form. Please try again.");
            }
        },
    });


    return (
        <div>
            <form
                onSubmit={formik.handleSubmit}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    <button
                        onClick={closeModal}
                        type="button"
                        className="close"
                        aria-label="Close"
                        style={{
                            border: "none",
                            background: "transparent",
                            fontSize: "20px",
                        }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                    <p
                        style={{
                            textAlign: "center",
                            width: "100%",
                            fontSize: "15px",
                            fontWeight: "500",
                            margin: "0",
                        }}
                    >
                        {modalOpenStatus === "edit"
                            ? "Update instagram configuration"
                            : "Create instagram configuration"}
                    </p>
                </div>

                {/* Form Fields */}
                {[
                    { label: "Access token", name: "access_token" },
                    { label: "IG user id", name: "ig_user_id" },

                ].map((field) => (
                    <div style={{ display: "flex", flexDirection: "column" }} key={field.name}>
                        <label className="required" style={{ fontSize: "14px" }}>
                            {field.label}
                        </label>
                        <input
                            {...formik.getFieldProps(field.name)}
                            className={clsx(
                                "form-control form-control-lg form-control-solid",
                                {
                                    "is-invalid": formik.touched[field.name] &&
                                        formik.errors[field.name],
                                },
                                {
                                    "is-valid": formik.touched[field.name] &&
                                        !formik.errors[field.name],
                                }
                            )}
                            style={{ padding: "10px" }}
                        />
                        {formik.touched[field.name] && formik.errors[field.name] && (
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block" style={{ color: "red" }}>
                                    {formik.errors[field.name]}
                                </div>
                            </div>
                        )}
                    </div>
                ))}

                {/* Submit Button */}
                <div style={{ width: "100%" }}>
                    <button
                        type="submit"
                        style={{ width: "100%", textAlign: "center" }}
                        className="btn btn-primary"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                Submitting... <Loader />
                            </>
                        ) : (
                            modalOpenStatus === "edit" ? "Update" : "Submit"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default WhatsAppModal;
